/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { CollectionNestedOption } from '../../core/nested-option';



export class DxiLegendComponent extends CollectionNestedOption {
    
    get backgroundColor(): string {
        return this._getOption('backgroundColor');
    }
    set backgroundColor(value: string) {
        this._setOption('backgroundColor', value);
    }

    
    get border(): any {
        return this._getOption('border');
    }
    set border(value: any) {
        this._setOption('border', value);
    }

    
    get columnCount(): number {
        return this._getOption('columnCount');
    }
    set columnCount(value: number) {
        this._setOption('columnCount', value);
    }

    
    get columnItemSpacing(): number {
        return this._getOption('columnItemSpacing');
    }
    set columnItemSpacing(value: number) {
        this._setOption('columnItemSpacing', value);
    }

    
    get customizeHint(): Function {
        return this._getOption('customizeHint');
    }
    set customizeHint(value: Function) {
        this._setOption('customizeHint', value);
    }

    
    get customizeText(): Function {
        return this._getOption('customizeText');
    }
    set customizeText(value: Function) {
        this._setOption('customizeText', value);
    }

    
    get font(): DevExpress.viz.Font {
        return this._getOption('font');
    }
    set font(value: DevExpress.viz.Font) {
        this._setOption('font', value);
    }

    
    get horizontalAlignment(): string {
        return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value: string) {
        this._setOption('horizontalAlignment', value);
    }

    
    get itemsAlignment(): string {
        return this._getOption('itemsAlignment');
    }
    set itemsAlignment(value: string) {
        this._setOption('itemsAlignment', value);
    }

    
    get itemTextPosition(): string {
        return this._getOption('itemTextPosition');
    }
    set itemTextPosition(value: string) {
        this._setOption('itemTextPosition', value);
    }

    
    get margin(): number|
        { bottom?: number, left?: number, right?: number, top?: number } {
        return this._getOption('margin');
    }
    set margin(value: number|
        { bottom?: number, left?: number, right?: number, top?: number }) {
        this._setOption('margin', value);
    }

    
    get markerColor(): string {
        return this._getOption('markerColor');
    }
    set markerColor(value: string) {
        this._setOption('markerColor', value);
    }

    
    get markerShape(): string {
        return this._getOption('markerShape');
    }
    set markerShape(value: string) {
        this._setOption('markerShape', value);
    }

    
    get markerSize(): number {
        return this._getOption('markerSize');
    }
    set markerSize(value: number) {
        this._setOption('markerSize', value);
    }

    
    get orientation(): string {
        return this._getOption('orientation');
    }
    set orientation(value: string) {
        this._setOption('orientation', value);
    }

    
    get paddingLeftRight(): number {
        return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value: number) {
        this._setOption('paddingLeftRight', value);
    }

    
    get paddingTopBottom(): number {
        return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value: number) {
        this._setOption('paddingTopBottom', value);
    }

    
    get rowCount(): number {
        return this._getOption('rowCount');
    }
    set rowCount(value: number) {
        this._setOption('rowCount', value);
    }

    
    get rowItemSpacing(): number {
        return this._getOption('rowItemSpacing');
    }
    set rowItemSpacing(value: number) {
        this._setOption('rowItemSpacing', value);
    }

    
    get source(): any {
        return this._getOption('source');
    }
    set source(value: any) {
        this._setOption('source', value);
    }

    
    get verticalAlignment(): string {
        return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value: string) {
        this._setOption('verticalAlignment', value);
    }

    
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }

    protected get _optionPath() {
        return 'legends';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxi-legend',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'backgroundColor': [{ type: Input },],
'border': [{ type: Input },],
'columnCount': [{ type: Input },],
'columnItemSpacing': [{ type: Input },],
'customizeHint': [{ type: Input },],
'customizeText': [{ type: Input },],
'font': [{ type: Input },],
'horizontalAlignment': [{ type: Input },],
'itemsAlignment': [{ type: Input },],
'itemTextPosition': [{ type: Input },],
'margin': [{ type: Input },],
'markerColor': [{ type: Input },],
'markerShape': [{ type: Input },],
'markerSize': [{ type: Input },],
'orientation': [{ type: Input },],
'paddingLeftRight': [{ type: Input },],
'paddingTopBottom': [{ type: Input },],
'rowCount': [{ type: Input },],
'rowItemSpacing': [{ type: Input },],
'source': [{ type: Input },],
'verticalAlignment': [{ type: Input },],
'visible': [{ type: Input },],
};
}


export class DxiLegendModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxiLegendComponent
  ],
  exports: [
    DxiLegendComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
